import { ascend, compose, path, prop, sortWith } from 'ramda';
import { createSelector } from 'reselect';

import { getCodelistPropById } from 'utils';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getRegions = compose(prop('regions'), getRoot);

export const getSortedRegionsByIdAndChannelName = createSelector(
	getRegions,
	(_, campaignChannels) => campaignChannels,
	(regions, campaignChannels) => {
		const byIdAndChannel = sortWith([ascend(path(['orgStructure', 'regionId'])), ascend(prop('channelName'))]);

		const regionsWithChannelName = regions.map((region) => {
			const { orgStructure } = region;

			return {
				...region,
				channelName: getCodelistPropById(orgStructure.channelId, campaignChannels),
			};
		});

		return byIdAndChannel(regionsWithChannelName);
	},
);
